
/* injects from baggage-loader */

'use strict';

import ProjectDonationWizardStep0Component from './project-donation-wizard.step0.component';

const ProjectDonationWizardStep0PageModule = angular.module('project-donation-wizard-step-0-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('project-donation-wizard.step0', {
        url: '/0',
        component: 'projectDonationWizardStep0',
        // Resolve promises into controller bindings, see component for bindings
        resolve: { }
      });
  })
  .component('projectDonationWizardStep0', new ProjectDonationWizardStep0Component());

export default ProjectDonationWizardStep0PageModule;



// WEBPACK FOOTER //
// ./src/app/pages/project-donation-wizard/step0/project-donation-wizard.step0.module.js